export function groupCodeToName(groupCode: string, withGroupCode = true) {
  let name = 'Unknown Group';
  switch (groupCode) {
    case 'LA':
      name = 'Los Angeles';
      break;
    case 'CA':
      name = 'California';
      break;
    case 'NC':
      name = 'North Carolina';
      break;
    case 'SC':
      name = 'South Carolina';
      break;
    case 'IL':
      name = 'Illinois';
      break;
    case 'LL':
      name = 'Louisiana';
      break;
    case 'OC':
      name = 'Orange County';
      break;
    case 'AT':
      name = 'Atlanta';
      break;
    case 'NJ':
      name = 'New Jersey';
      break;
    case 'NY':
      name = 'New York';
      break;
    case 'WA':
      name = 'Washington';
      break;
    case 'VA':
      name = 'Virginia';
      break;
    case 'MD':
      name = 'Maryland';
      break;
    case 'GA':
      name = 'Georgia';
      break;
  }

  if (withGroupCode) {
    return `${name} - ${groupCode}`;
  } else {
    return name;
  }
}
